export default __webpack_public_path__ + "static/media/TATI_Claim_Form.8937d72c.pdf";